import { useSelector } from 'react-redux';
import { ApplicationState } from '../rootStore';

export const useDamageAreaReducer = () =>
  useSelector((state: ApplicationState) => state.damageArea);
